import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject, combineLatest, map } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InsightsState, LoadInsightInactiveSuccess, LoadInsightsSuccess, LoadInsightSuccess } from '../../../redux';
import { ViewInsightComponent } from '../view-insight.component';
import { Insight } from 'src/app/models/insight';

@Component({
  selector: 'app-modal-container-insight',
  template: ''
})
export class ModalContainerInsightComponent implements OnDestroy, OnInit {
  public insightsActive$: Observable<Insight[]> = inject(Store).select(InsightsState.insightsActive);
  public insightsInactive$: Observable<Insight[]> = inject(Store).select(InsightsState.insightsInactive);
  private unsubscribe = new Subject<void>();

  public tableData?: Insight[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    combineLatest([this.insightsActive$, this.insightsInactive$])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([active, inactive]) => (this.tableData = [...(active ?? []), ...(inactive ?? [])]));
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      if (this.tableData?.length) {
        const found = this.tableData.find((element) => String(element.id) === params.id);

        if (found) {
          this.dialogService
            .open(ViewInsightComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                insight: found
              }
            })
            .onClose.subscribe(() => {
              this.router.navigateByUrl('insights/table');
            });
        } else {
          this.router.navigateByUrl('insights/table');
        }
      } else {
        this.actions$
          .pipe(ofActionSuccessful(LoadInsightsSuccess, LoadInsightInactiveSuccess), takeUntil(this.unsubscribe))
          .subscribe(() => {
            const found = this.tableData.find((element) => String(element.id) === params.id);
            if (found) {
              this.dialogService
                .open(ViewInsightComponent, {
                  closeOnEsc: false,
                  closeOnBackdropClick: false,
                  context: {
                    insight: found
                  }
                })
                .onClose.subscribe(() => {
                  this.router.navigateByUrl('insights/table');
                });
            } else {
              this.router.navigateByUrl('insights/table');
            }
          });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
